import React from 'react';
import { getAttribute } from '@broadleaf/admin-components/dist/metadata/utils/MetadataUtils';
import { evaluateConditionals } from '@broadleaf/admin-components/dist/common/services/ConditionalHelper';
import TriggerEndpoint from '@broadleaf/admin-components/dist/view/named-components/view-types/EntityView/action-components/secondary/TriggerEndpoint';

/**
 * A wrapper component that enables Actions.conditionalAction() for PRIMARY or SECONDARY placement
 */
const ConditionalTriggerAction = (props: any) => {
  const { actionDefinition, formik } = props;
  const conditionals = getAttribute(actionDefinition, 'conditionals', []);
  const shouldRender = evaluateConditionals(conditionals, formik.values);

  if (!shouldRender) {
    return null; // Do not render the button if conditions aren't met
  }

  return <TriggerEndpoint {...props} />;
};

export default ConditionalTriggerAction;
